"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGendersServerQueryOptions = exports.getGendersServer = exports.useGetGendersQueryOptions = exports.useGetGendersHook = exports.useGetLanguagesServerQueryOptions = exports.getLanguagesServer = exports.useGetLanguagesQueryOptions = exports.useGetLanguagesHook = exports.useGetTitlesServerQueryOptions = exports.getTitlesServer = exports.useGetTitlesQueryOptions = exports.useGetTitlesHook = void 0;
exports.useGetTitles = useGetTitles;
exports.useGetTitlesServer = useGetTitlesServer;
exports.useGetLanguages = useGetLanguages;
exports.useGetLanguagesServer = useGetLanguagesServer;
exports.useGetGenders = useGetGenders;
exports.useGetGendersServer = useGetGendersServer;
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const useQueryFetch_1 = require("../../utils/orval/useQueryFetch");
const queryFetch_1 = require("../../utils/orval/queryFetch");
const queryKeyMutator_1 = require("../../utils/orval/queryKeyMutator");
/**
 * Search for all titles in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
const useGetTitlesHook = () => {
    const getTitles = (0, useQueryFetch_1.useQueryFetch)();
    return (0, react_1.useCallback)((params, operationName = 'getTitles', options, signal) => {
        return getTitles({ url: `/api/aem/general/title/all`, method: 'GET', params, signal }, Object.assign({ operationName: 'getTitles' }, options));
    }, [getTitles]);
};
exports.useGetTitlesHook = useGetTitlesHook;
const useGetTitlesQueryOptions = (params, operationName = 'getTitles', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/api/aem/general/title/all`, queryOptions });
    const getTitles = (0, exports.useGetTitlesHook)();
    const queryFn = ({ signal }) => getTitles(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetTitlesQueryOptions = useGetTitlesQueryOptions;
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
function useGetTitles(params, operationName = 'getTitles', options) {
    const queryOptions = (0, exports.useGetTitlesQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Search for all titles in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
const getTitlesServer = (params, operationName = 'getTitles', options, signal) => {
    return (0, queryFetch_1.queryFetch)({ url: `/masterdata/title/all`, method: 'GET', params, signal }, Object.assign({ operationName: 'getTitles' }, options));
};
exports.getTitlesServer = getTitlesServer;
const useGetTitlesServerQueryOptions = (params, operationName = 'getTitles', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/masterdata/title/all`, queryOptions });
    const queryFn = ({ signal }) => (0, exports.getTitlesServer)(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetTitlesServerQueryOptions = useGetTitlesServerQueryOptions;
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
function useGetTitlesServer(params, operationName = 'getTitles', options) {
    const queryOptions = (0, exports.useGetTitlesServerQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Search for all languages in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
const useGetLanguagesHook = () => {
    const getLanguages = (0, useQueryFetch_1.useQueryFetch)();
    return (0, react_1.useCallback)((params, operationName = 'getLanguages', options, signal) => {
        return getLanguages({ url: `/api/aem/general/language/all`, method: 'GET', params, signal }, Object.assign({ operationName: 'getLanguages' }, options));
    }, [getLanguages]);
};
exports.useGetLanguagesHook = useGetLanguagesHook;
const useGetLanguagesQueryOptions = (params, operationName = 'getLanguages', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/api/aem/general/language/all`, queryOptions });
    const getLanguages = (0, exports.useGetLanguagesHook)();
    const queryFn = ({ signal }) => getLanguages(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetLanguagesQueryOptions = useGetLanguagesQueryOptions;
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
function useGetLanguages(params, operationName = 'getLanguages', options) {
    const queryOptions = (0, exports.useGetLanguagesQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Search for all languages in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
const getLanguagesServer = (params, operationName = 'getLanguages', options, signal) => {
    return (0, queryFetch_1.queryFetch)({ url: `/masterdata/language/all`, method: 'GET', params, signal }, Object.assign({ operationName: 'getLanguages' }, options));
};
exports.getLanguagesServer = getLanguagesServer;
const useGetLanguagesServerQueryOptions = (params, operationName = 'getLanguages', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/masterdata/language/all`, queryOptions });
    const queryFn = ({ signal }) => (0, exports.getLanguagesServer)(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetLanguagesServerQueryOptions = useGetLanguagesServerQueryOptions;
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
function useGetLanguagesServer(params, operationName = 'getLanguages', options) {
    const queryOptions = (0, exports.useGetLanguagesServerQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Search for all genders in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
const useGetGendersHook = () => {
    const getGenders = (0, useQueryFetch_1.useQueryFetch)();
    return (0, react_1.useCallback)((params, operationName = 'getGenders', options, signal) => {
        return getGenders({ url: `/api/aem/general/gender/all`, method: 'GET', params, signal }, Object.assign({ operationName: 'getGenders' }, options));
    }, [getGenders]);
};
exports.useGetGendersHook = useGetGendersHook;
const useGetGendersQueryOptions = (params, operationName = 'getGenders', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/api/aem/general/gender/all`, queryOptions });
    const getGenders = (0, exports.useGetGendersHook)();
    const queryFn = ({ signal }) => getGenders(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetGendersQueryOptions = useGetGendersQueryOptions;
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
function useGetGenders(params, operationName = 'getGenders', options) {
    const queryOptions = (0, exports.useGetGendersQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Search for all genders in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
const getGendersServer = (params, operationName = 'getGenders', options, signal) => {
    return (0, queryFetch_1.queryFetch)({ url: `/masterdata/gender/all`, method: 'GET', params, signal }, Object.assign({ operationName: 'getGenders' }, options));
};
exports.getGendersServer = getGendersServer;
const useGetGendersServerQueryOptions = (params, operationName = 'getGenders', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/masterdata/gender/all`, queryOptions });
    const queryFn = ({ signal }) => (0, exports.getGendersServer)(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetGendersServerQueryOptions = useGetGendersServerQueryOptions;
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
function useGetGendersServer(params, operationName = 'getGenders', options) {
    const queryOptions = (0, exports.useGetGendersServerQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
//# sourceMappingURL=customer-service.js.map